export const navigateToBookedAppointment = (navigate, uuid, state = {}) => {
    navigate(`/appointment/${uuid}`, {
      state: {
        makeAnOtherAppointmentOnly: true,
        ...state,
      },
    });
  };